/*
 * axios封装
 * */
import { Message } from "element-ui";
import { API_URL } from  "../data/Url.js";
export default function axiosUtil(options, succCallback, errCallback){
    axios({
        url: API_URL,
        method: "post",
        data: Object.assign(options),
        headers: {'Content-type': 'application/json;charset=UTF-8'}
    }).then(function(res){
        if(res.data.succ){
            succCallback(res.data);
        }else {
            if(errCallback){//发生错误时执行的回掉函数
                errCallback(res.data);
            }
            Message({
                showClose: true,
                message: res.data.msg,
                type: "warning"
            });
        }
    }).catch(function(res){
        
        // Message({
        //     showClose: true,
        //     message: "02",
        //     type: "warning"
        // });
    });
}
